import { requestLaravel } from "../../../../utils/api";
import { ApiResponse, IUser } from "../../core/_models";
type IUserResponse = {
    list: IUser[]
}
export function getUsers(keyword: string = "") {
    return requestLaravel<ApiResponse<IUserResponse>>("/users/get-user-list", { keyword });
}